import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { provideSoftAppsRoutes, SoftAppsFeature } from '@softapps/core';
import { CommandStore, SOFTLINE_FEATURE_COMMANDS } from '@softline/application';
import { LoginService, LogoutService, provideJwtAuthentication } from '@softline/auth';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { loginRoutes } from './login.routes';
import {
  AuthenticationHooks,
  SOFTLINE_CONFIG_AUTHENTICATION_HOOKS,
  SOFTLINE_CONFIG_LOGIN,
} from '@softapps/core/login';
import { SoftAppsLoginService } from './services/login.service';
import { SoftAppsLogoutService } from '@softapps/core/login';
import { GuardService } from '@softapps/core/login';
import { ContextStorageService } from '@softapps/core/context';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export function withLogin(): SoftAppsFeature {
  return {
    providers: [
      provideJwtAuthentication(),
      ...loginProviders,
      provideSoftAppsRoutes({ public: loginRoutes }),
    ],
  };
}

/***@deprecated***/
export const loginProviders: (Provider | EnvironmentProviders)[] = [
  ContextStorageService,
  { provide: SOFTLINE_CONFIG_LOGIN, useValue: { scan: false } },
  { provide: LogoutService, useExisting: SoftAppsLogoutService },
  { provide: LoginService, useExisting: SoftAppsLoginService },
  { provide: GuardService, useClass: GuardService },

  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    const logoutService = inject(LogoutService);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'login',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'login',
      language: 'en',
      translations: en,
    });

    store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: 'login',
      commands: [
        {
          icon: 'fa-regular fa-arrow-right-from-bracket',
          name: '#LOGOUT.TITLE',
          class: 'menu main-menu main-menu-bottom info',
          execute: () => {
            logoutService.logout();
          },
        },
      ],
    });
  }),
];
